<script lang="ts" setup>
    import { OffsetGroup } from '~/data/OffsetGroup'

    defineProps<{
        content: string
        toOffset: number
    }>()
</script>

<template>
    <div class="layout-grid overflow-hidden uppercase">
        <div class="gutter-y" :class="OffsetGroup.default().classes">
            <div class="opacity-0" data-aos="fade-up" data-aos-offset="-50">
                Room
            </div>

            <div class="to text-center" :style="`--offset: ${toOffset}%`">
                <div
                    class="opacity-0"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-offset="-50"
                >
                    to
                </div>
            </div>

            <div class="text-right">
                <div
                    v-for="(word, i) in content.split(' ')"
                    data-aos="fade-up"
                    :data-aos-delay="200 + 100 * i"
                    data-aos-offset="-50"
                    class="inline-block opacity-0"
                >
                    {{ word }}
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    div {
        font-size: clamp(3.125rem, 0.85rem + 9.709vw, 12.5rem);
        line-height: 0.9;
    }

    .to {
        transform: translateX(var(--offset));
    }

    .text-right {
        div + div {
            margin-left: 0.4em;
        }
    }
</style>
